module.exports = __webpack_public_path__ + "img/Flag_of_Puerto_Rico.6eb96f07.svg";